<ng-container *ngIf="isCodeValid">
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<div class="flex flex-column gap-2">
			<main class="grid formgrid p-fluid">				
				<div class="field col-12 md:col-4 md:col-offset-4">
					<label for="password" class="blue-bold-text">{{translations.contrasena}}<span
							style="color: red">*</span></label>
					<p-password id="password" formControlName="password" [toggleMask]="true">
						<ng-template pTemplate="footer">
							<div>
								<p-divider />
								<p class="mt-2 bold">{{translations.sugerencias}}</p>
								<ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
									<li>{{translations.alMenosUnaMinuscula}}</li>
									<li>{{translations.alMenosUnaMayuscula}}</li>
									<li>{{translations.alMenosUnNumero}}</li>
									<li>{{translations.minimoCaracteres}}</li>
									<li>{{translations.maximoCaracteres}}</li>
									<li>{{translations.alMenosUnCaracterEspecial}}</li>
								</ul>
							</div>
						</ng-template>
					</p-password>
					<ng-container *ngIf="form.get('password')?.touched">
						<app-form-group-error-message [control]="form.get('password')"></app-form-group-error-message>
						<small id="passwordRepeat-help" class="p-error block"
							*ngIf="form.get('passwordRepeat')?.touched && form.errors?.['notMatch']">
							{{translations.constasenaNoCoiniciden}}
						</small>
					</ng-container>
				</div>
				<div class="field col-12 md:col-4 md:col-offset-4">
					<label for="passwordRepeat" class="blue-bold-text">{{translations.repitaContrasena}}<span
							style="color: red">*</span></label>
					<p-password formControlName="passwordRepeat" id="passwordRepeat" [toggleMask]="true" [feedback]="false"/>
					<ng-container *ngIf="form.get('passwordRepeat')?.invalid && form.get('passwordRepeat')?.touched">
						<small id="passwordRepeat-help" class="p-error block">
							{{translations.campoRequerido}}
						</small>
					</ng-container>
				</div>
				<div class="field col-12 md:col-4 md:col-offset-4">
					<div class="flex justify-content-center">
						<button pButton type="submit" [label]="translations.cambiarContrasena" icon="pi pi-save" iconPos="right"
							class="tax-app-button w-full"></button>
					</div>
				</div>
			</main>
		</div>
	</form>
</ng-container>